module.exports = {
      id: "paywalliconbenefitthree-usage",
      viewBox: "0 0 31.097 36.378",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#paywalliconbenefitthree",
      toString: function () {
        return this.url;
      }
    }